import React, { useState } from 'react';
import { CircularProgress, Grid } from '@material-ui/core';
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { isToken, isTrialMode, showAuthModal, userDetails } from 'store/auth/actions';
import { updateOAuthMoreDetails } from 'api/userRequests';
import { useDispatch, useSelector } from 'react-redux';
import { DESIGN_CONFIG, STRING_CONFIG } from 'utils';
import { showToast } from 'store/platform/actions';
import SignUpInput from './Components/SignUpInput';
import Button from '../../ReusableComponents/Button';
import Text from '../../ReusableComponents/Text';
import Box from '../../ReusableComponents/Box';
import DatePickerInput from './Components/DatePickerInput';
import DropDown from './Components/Dropdown';
import UsernameInput from './Components/UsernameInput';
import { useMedia } from 'helpers';

function OAuthMoreDetails({
  isModal,
  userEmail,
  userImage,
}) {

  const authToken = useSelector((state) => state.auth.token);

  const dispatch = useDispatch();

  const userInfos = {
    confirmPassword: '',
    dateOfBirth: '',
    gender: '',
    password: '',
    username: '',
  };

  const [user, setUser] = useState(userInfos);

  const smallDevice = useMedia('(max-width:450px)');

  const [loading, setLoading] = useState(false);

  const { username } = user;

  const registerValidation = Yup.object({
    password: Yup.string()
      .notRequired()
      .min(8, (val) =>
        val ? STRING_CONFIG.validation.userProfile.password.invalidLength : ''
      )
      .max(64, (val) =>
        val ? STRING_CONFIG.validation.userProfile.password.invalidLength : ''
      )
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,64}$/,
        (val) =>
          val ? STRING_CONFIG.validation.userProfile.password.policyFailed : ''
      ),
    confirmPassword: Yup.string().test('passwords-match', function (value) {
      const { password } = this.parent;
      if (!password) return true;
      if (!value)
        return this.createError({
          message: STRING_CONFIG.validation.userProfile.confirmPassword.empty,
          path: this.path,
        });
      if (value !== password)
        return this.createError({
          message:
            STRING_CONFIG.validation.userProfile.confirmPassword
              .passwordDoNotMatch,
          path: this.path,
        });
      return true;
    }),
  });

  const registerSubmit = async (values, submitProp) => {
    try {
      setLoading(true);
      const userData = {
        dateOfBirth: user.dateOfBirth,
        gender: user.gender,
        password: values.password,
        username,
        email: userEmail,
      };
      if (values.password) {
        userData.password = values.password;
      }

      const { data } = await updateOAuthMoreDetails(userData, authToken);
      if (data.success === true) {
        const userDetailsObj = {
          dateOfBirth: data?.dateOfBirth,
          email: data.email,
          firstName: data.first_name,
          gender: data?.gender,
          image: userImage,
          isOAuth: data.isOAuth,
          lastName: data.last_name,
          username: data.username,
        };

        setLoading(false);

        dispatch(userDetails(userDetailsObj));

        dispatch(isTrialMode(null));

        localStorage.setItem("tour-for-you", "running");
        localStorage.setItem("tour-compare", "running");

        dispatch(isToken(data.token));

        dispatch(showAuthModal(false));
      }
    } catch (err) {
      setLoading(false);
      dispatch(showAuthModal(false));
      submitProp.setSubmitting(false);
      if (err.response || err.request) {
        dispatch(
          showToast(
            STRING_CONFIG.inPage.toastMessages.txtErrorSomethingWentWrong,
            'error',
            6000,
            false,
            true
          )
        );
      }
    }
  };
  return (
    <Formik
      initialValues={userInfos}
      validationSchema={registerValidation}
      onSubmit={registerSubmit}
      validateOnMount
    >
      {(formik) => (
        <Form
          background={DESIGN_CONFIG.color.neutral.neutral500}
          className='oauth-more-details'
          style={{
            borderRadius: isModal ? '.5rem' : '.75rem',
            margin: isModal
              ? 'auto'
              : smallDevice
                ? 'auto'
                : '0 auto',
          }}
        >
          <Box display='flex' flexDirection='column'>
            <h1
              style={{
                fontSize: `${DESIGN_CONFIG.typography.largeCards.webLgCardTitle.fontSize}`,
                fontWeight: `${DESIGN_CONFIG.typography.largeCards.webLgCardTitle.fontWeight}`,
                margin: 0,
              }}
            >
              {STRING_CONFIG.inPage.oAuthMoreDetails.txtTitle}
            </h1>
            <h3
              style={{
                color: `${DESIGN_CONFIG.color.text.text200}`,
                fontSize: `${DESIGN_CONFIG.typography.largeCards.webLgCardSubtitle.fontSize}`,
                fontWeight: `${DESIGN_CONFIG.typography.largeCards.webLgCardSubtitle.fontWeight}`,
                marginBottom: 0,
              }}
            >
              {STRING_CONFIG.inPage.oAuthMoreDetails.txtSubtext}
            </h3>
            <Box>
              <Grid container>
                <Grid item xs={12}>
                  <Box display='flex' maxW='580px' w='100%'>
                    <Box
                      display='flex'
                      flexDirection='column'
                      marginTop='0.313rem'
                      w='100%'
                    >
                      <Box
                        display='flex'
                        justifyContent='space-between'
                        marginBottom='.5rem'
                        marginRight='.25rem'
                      >
                        <Box display='flex'>
                          <Text
                            fontSize={
                              DESIGN_CONFIG.typography.common.webLabel.fontSize
                            }
                            fontWeight={
                              DESIGN_CONFIG.typography.common.webLabel
                                .fontWeight
                            }
                            margin={0}
                            textColor={DESIGN_CONFIG.color.text.text100}
                          >
                            {STRING_CONFIG.inPage.userProfile.lblUsername}
                          </Text>
                        </Box>
                      </Box>
                      <Box>
                        <UsernameInput
                          id='Username'
                          placeHolder={
                            STRING_CONFIG.inPage.userProfile.plHUsername
                          }
                          setUser={setUser}
                          type='text'
                          user={user}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12}>
                  <Box
                    display='flex'
                    flexDirection='column'
                    marginTop='0.313rem'
                  >
                    <Box
                      display='flex'
                      justifyContent='space-between'
                      marginBottom='.5rem'
                      marginRight='.25rem'
                    >
                      <Box display='flex'>
                        <Text
                          fontSize={
                            DESIGN_CONFIG.typography.common.webLabel.fontSize
                          }
                          fontWeight={
                            DESIGN_CONFIG.typography.common.webLabel.fontWeight
                          }
                          margin={0}
                          textColor={DESIGN_CONFIG.color.text.text100}
                        >
                          {STRING_CONFIG.inPage.userProfile.lblPassword}
                        </Text>
                        <span
                          style={{
                            background: `${DESIGN_CONFIG.color.neutral.neutral50}`,
                            borderRadius: '1111px',
                            fontSize: `${DESIGN_CONFIG.typography.common.webLabel.fontSize}`,
                            fontWeight: `${DESIGN_CONFIG.typography.common.webLabel.fontWeight}`,
                            marginBottom: '.5rem',
                            padding: '0 .5rem',
                            textColor: `${DESIGN_CONFIG.color.text.text200}`,
                          }}
                        >
                          {STRING_CONFIG.inPage.common.txtOptional}
                        </span>
                      </Box>
                    </Box>
                    <Box position='relative'>
                      <Field name='password'>
                        {(props) => {
                          const { field, meta } = props;
                          return (
                            <SignUpInput
                              field={field}
                              id='password'
                              meta={meta}
                              placeHolder={
                                STRING_CONFIG.inPage.userProfile.plHPassword
                              }
                              type='password'
                            />
                          );
                        }}
                      </Field>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    display='flex'
                    flexDirection='column'
                    marginBottom='.5rem'
                    marginTop='0.313rem'
                  >
                    <Box
                      display='flex'
                      justifyContent='space-between'
                      marginBottom='.5rem'
                      marginRight='.25rem'
                    >
                      <Box display='flex'>
                        <Text
                          fontSize={
                            DESIGN_CONFIG.typography.common.webLabel.fontSize
                          }
                          fontWeight={
                            DESIGN_CONFIG.typography.common.webLabel.fontWeight
                          }
                          margin={0}
                          textColor={DESIGN_CONFIG.color.text.text100}
                        >
                          {STRING_CONFIG.inPage.userProfile.lblConfirmPassword}
                        </Text>
                        <span
                          style={{
                            background: `${DESIGN_CONFIG.color.neutral.neutral50}`,
                            borderRadius: '1111px',
                            fontSize: `${DESIGN_CONFIG.typography.common.webLabel.fontSize}`,
                            fontWeight: `${DESIGN_CONFIG.typography.common.webLabel.fontWeight}`,
                            marginBottom: '.5rem',
                            padding: '0 .5rem',
                            textColor: `${DESIGN_CONFIG.color.text.text200}`,
                          }}
                        >
                          {STRING_CONFIG.inPage.common.txtOptional}
                        </span>
                      </Box>
                    </Box>
                    <Box position='relative'>
                      <Field name='confirmPassword'>
                        {(props) => {
                          const { field, meta } = props;
                          return (
                            <SignUpInput
                              field={field}
                              id='confirmPassword'
                              meta={meta}
                              placeHolder={
                                STRING_CONFIG.inPage.userProfile
                                  .plHConfirmPassword
                              }
                              type='password'
                            />
                          );
                        }}
                      </Field>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Box display='flex' gap='1rem' justifyContent='space-between'>
            <Box>
              <Box alignItems='center' display='flex' gap='.5rem'>
                <Text
                  fontSize={DESIGN_CONFIG.typography.common.webLabel.fontSize}
                  fontWeight={
                    DESIGN_CONFIG.typography.common.webLabel.fontWeight
                  }
                  marginBottom='.5rem'
                  textColor={DESIGN_CONFIG.color.text.text200}
                >
                  {STRING_CONFIG.inPage.userProfile.lblGender}
                </Text>
                <span
                  style={{
                    background: `${DESIGN_CONFIG.color.neutral.neutral50}`,
                    borderRadius: '1111px',
                    fontSize: `${DESIGN_CONFIG.typography.common.webLabel.fontSize}`,
                    fontWeight: `${DESIGN_CONFIG.typography.common.webLabel.fontWeight}`,
                    marginBottom: '.5rem',
                    padding: '0 .5rem',
                    textColor: `${DESIGN_CONFIG.color.text.text200}`,
                  }}
                >
                  {STRING_CONFIG.inPage.common.txtOptional}
                </span>
              </Box>
              <DropDown setUser={setUser} />
            </Box>
            <Box>
              <Box alignItems='center' display='flex' gap='.5rem'>
                <Text
                  fontSize={DESIGN_CONFIG.typography.common.webLabel.fontSize}
                  fontWeight={
                    DESIGN_CONFIG.typography.common.webLabel.fontWeight
                  }
                  marginBottom='.5rem'
                  textColor={DESIGN_CONFIG.color.text.text200}
                >
                  {STRING_CONFIG.inPage.userProfile.lblDateOfBirth}
                </Text>
                <span
                  style={{
                    background: `${DESIGN_CONFIG.color.neutral.neutral50}`,
                    borderRadius: '1111px',
                    fontSize: `${DESIGN_CONFIG.typography.common.webLabel.fontSize}`,
                    fontWeight: `${DESIGN_CONFIG.typography.common.webLabel.fontWeight}`,
                    marginBottom: '.5rem',
                    padding: '0 .5rem',
                    textColor: `${DESIGN_CONFIG.color.text.text200}`,
                  }}
                >
                  {STRING_CONFIG.inPage.common.txtOptional}
                </span>
              </Box>
              <DatePickerInput setUser={setUser} />
            </Box>
          </Box>
          <Button
            alignItems='center'
            aria-disabled={
              !username ||
              (formik.values.password && !formik.isValid) ||
              formik.isSubmitting
            }
            background={DESIGN_CONFIG.color.primary.primaryMain}
            border='none'
            borderRadius='6px'
            cursor='pointer'
            disabled={
              !username ||
              (formik.values.password && !formik.isValid) ||
              formik.isSubmitting
            }
            display='flex'
            justifyContent='center'
            marginTop='1rem'
            padding='.5rem 0'
            transition='all 0.3s ease-in'
            w='100%'
          >
            <Text
              fontSize={DESIGN_CONFIG.typography.common.webButton.fontSize}
              fontWeight={DESIGN_CONFIG.typography.common.webButton.fontWeight}
              marginBottom='0'
              textColor={DESIGN_CONFIG.color.neutral.neutral500}
            >
              {loading ? (
                <CircularProgress size={18} color={DESIGN_CONFIG.color.neutral.neutral500} />
              ) : (
                STRING_CONFIG.inPage.oAuthMoreDetails.btnFinishSetup
              )}
            </Text>
          </Button>
        </Form>
      )}
    </Formik>
  );
}

export default OAuthMoreDetails;
